import TypeUtils from "./TypeUtils";
import Registry from "../registry";
import sortby from "lodash.sortby";

const walkDownTree = (data, parentId = null, nodes = []) => {
  const children = data.filter(v => v.parent_id === parentId);
  if (children && children.length) {
    children.map(child => {
      nodes.push(child);
      walkDownTree(data, child.id, nodes);
    });
  }

  return nodes;
};

export const sort = (arr = []) => sortby(arr, "display_order");

export const truncate = (text = "", size = 80) => {
  if (text && typeof text === "string" && text.length > size) {
    return text.substring(0, size) + "...";
  }
  return text;
};

const ContentUtils = {
  displayName(content, type) {
    let fields = ContentUtils.displayFields(content, type);
    if (fields.length) {
      return content[fields[0]];
    } else {
      return "Untitled";
    }
  },

  displayFields(content, type) {
    return TypeUtils.displayFields(type).filter(
      partName => content[partName] !== undefined
    );
  },

  contentType(content, types) {
    return types
      .filter(type => type.id === content.document_definition_id)
      .shift();
  },

  partValue(content, partDefinitionId) {
    return content.content
      .filter(part => part.part_definition_id === partDefinitionId)
      .shift();
  },

  renderContent(content, type) {
    const field = TypeUtils.displayFields(type).shift();
    const partDefinition = type.parts.find(part => part.name === field);

    return ContentUtils.renderPart(content, field, partDefinition);
  },

  renderPart(content, field, partDefinition) {
    if (!content) return null;

    if (!partDefinition) {
      return content[field] || "Untitled";
    }

    const part = Registry.get(partDefinition.type || "text").schema(
      partDefinition
    );
    const value = content[field];
    return (
      (part.render && part.render({ content, field, value })) ||
      value ||
      "Untitled"
    );
  },

  sort(content, type) {
    const options = type.options || {};
    const sortKey = options.sort_method || "date_created";
    const sortDir = options.sort_order || "desc";
    let key = sortKey;
    if (key === "hierarchy") {
      return ContentUtils.flatTreeSort(content);
    }
    if (key === "manual") {
      key = "position";
    }
    const dir = sortDir === "asc" ? 1 : -1;
    return sortby(content, item => {
      let val = item[key];
      if (key.match(/date/)) {
        val = new Date(val);
      }
      return val * dir;
    });
  },

  flatTreeSort(content) {
    return walkDownTree(content);
  }
};

export default ContentUtils;



// WEBPACK FOOTER //
// ./app/lib/ContentUtils.js